import * as angular from 'angular';

export class DateService {
    constructor() {}

    checkIsValidDate(date) {
        var regEx = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
        return date.match(regEx);
    }

    createDateFormat(date) {
        const getDay = date.getDate(),
            getMonth = date.getMonth() + 1,
            getFullYear = date.getFullYear();

        return getFullYear + '-' + getMonth + '-' + getDay;
    }

    generateYears(startYear, endYear) {
        var date = new Date();
        var currentYear = endYear || date.getFullYear();
        var yearsList = [];
        for (startYear; startYear <= currentYear; startYear++) {
            yearsList.unshift(startYear);
        }
        return yearsList;
    }

    getFirstDayOfTheMonth(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    getLastDayOfTheMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    getMonths() {
        return [
            { name: 'Styczeń', id: 1 },
            { name: 'Luty', id: 2 },
            { name: 'Marzec', id: 3 },
            { name: 'Kwiecień', id: 4 },
            { name: 'Maj', id: 5 },
            { name: 'Czerwiec', id: 6 },
            { name: 'Lipiec', id: 7 },
            { name: 'Sierpień', id: 8 },
            { name: 'Wrzesień', id: 9 },
            { name: 'Październik', id: 10 },
            { name: 'Listopad', id: 11 },
            { name: 'Grudzien', id: 12 },
        ];
    }
}

angular.module('app').service('DateService', DateService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/date.service.ts